<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t('edit_model')}}</h4>
                    <p class="text-subtitle">{{$t("edit_a_model")}}</p>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-form ref="form">
                <v-row class="mt-2">
                    <v-col cols="12" md="6">
                        <v-text-field
                            outlined
                            dense
                            :label="$t('name')"
                            hide-details="auto"
                            v-model="form.name"
                            :rules="[isRequired]"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="3">
                        <v-btn color="primary" block @click="handleSave" :loading="loading">
                            <v-icon left>mdi-content-save</v-icon>
                            {{$t('save')}}
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="3" @click="handleCancel">
                        <v-btn depressed block>
                            {{$t('cancel')}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </div>
        <div v-else>
             <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-3"/>
                    <v-skeleton-loader type="text" class="my-3"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="me-5"/>
                    <v-skeleton-loader type="button"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import service from './../../services/fleet/model';
import PAlert from './../../components/common/PAlert.vue';
import { isRequired } from './../../utils/validations';

export default {
    components: {
        PAlert
    },
    data() {
        return {
            form: {
                name: "",
                brand_id: null
            },
            loading: false,
            dataLoading: false,
            id: null,
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
            brandName: null
        }
    },
    methods: {
        isRequired,
         fetchModel() {
            this.dataLoading = true;
            service.get(this.id).then(response => {
                this.form = response.data
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            service.update(this.id, {... this.form, brand_id: this.form.brand.id}).then(response => {
                this.$router.replace({ name: "ModelDisplay", params: { modelID: response.data.id } })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, model: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.form.brand_id = this.$route.params.brandID
        this.brandName = this.$route.query.brandName
        this.id = this.$route.params.modelID
        this.fetchModel()
    }
}
</script>

<style>

</style>